<mat-card appearance="outlined" class="mat-elevation-z1 mat-card-scrollable cssload-container">
    @if (isChanging()) {
        <div class="cssload-layer">
            <div class="cssload-whirlpool"></div>
            <div class="cssload-whirlpool-label">{{ 'DeliveryMethod.PleaseWaitValidating' | translate }}</div>
        </div>
    }
    <ng-container>
        <mat-card-header>
            <mat-card-title>{{ 'DeliveryMethod.Title' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <div>
                <div>
                    @if (currentDeliveryMethodId() === DeliveryMethodEnum.Electronic) {
                        <div>
                            {{
                                'DeliveryMethod.DeliveryMethodMessageElectronic'
                                    | translate: { value: $safeNavigationMigration(deliveryMethod()?.email) }
                            }}
                        </div>
                    } @else {
                        <div>{{ 'DeliveryMethod.DeliveryMethodMessagePaper' | translate }}</div>
                    }
                </div>
                <div class="mt-2">
                    <a mat-stroked-button (click)="changeDeliveryMethod()" target="_blank">
                        {{
                            (currentDeliveryMethodId() === DeliveryMethodEnum.Electronic
                                ? 'DeliveryMethod.ChangeToPaper'
                                : 'DeliveryMethod.ChangeToElectronic'
                            ) | translate
                        }}
                    </a>
                </div>
            </div>
        </mat-card-content>
    </ng-container>
    <ng-template #loadingTpl>{{ 'General.Loading' | translate }}...</ng-template>
</mat-card>
